import { useTenant } from '@parcel2go/npm-p2g-app';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';

export const useCompanyName = () => {
  const { settings } = useTenant();
  return settings[TenantSettingKeys.CompanyName] || '';
};
